import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { PropTypes } from 'prop-types';
/**
 * The ScrollToTop component handles the the scroll to top of page.
 *
 * @class ScrollToTop
 * @extends {Component}
 */

var ScrollToTop = /*#__PURE__*/function (_Component) {
  _inherits(ScrollToTop, _Component);

  var _super = _createSuper(ScrollToTop);

  function ScrollToTop() {
    _classCallCheck(this, ScrollToTop);

    return _super.apply(this, arguments);
  }

  _createClass(ScrollToTop, [{
    key: "componentDidUpdate",

    /**
     * The componentDidMount is called after updates occur. The ScrollToTop componentDidMount
     * resets the window position to the top of the page when the current property location
     * is not equal to the previous properties location.
     *
     * See https://reactjs.org/docs/react-component.html#componentdidupdate
     *
     * @param prevProps The component previous properties.
     * @memberof ScrollToTop
     */
    value: function componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        window.scrollTo(0, 0);
      }
    }
    /**
     * Renders the ScrollToTop element content.
     *
     * See https://reactjs.org/docs/react-component.html#render
     *
     * @memberof ScrollToTop
     */

  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return ScrollToTop;
}(Component);

ScrollToTop.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired
} : {};
/**
 * Provides scroll restoration as noted by
 * {@link https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/docs/guides/scroll-restoration.md|React Router}
 */

export default withRouter(ScrollToTop);